import { create } from "zustand";

// Store para manejar el creado, actualización y borrado de contactos.
// contacts: Array de contactos. Con el formato { id: string, name: string, phone: string }
// setContacts: Función para establecer el array completo de contactos.
// add: Función para agregar un nuevo contacto.
// update: Función para actualizar un contacto existente, donde updatedContact contiene el objeto ya editado retornado por el backend.
// remove: Función para eliminar un contacto por su ID.

const mapContactToOption = (contact) => {
    const name = contact?.name?.trim()
        ? contact.name
        : "🚫 Sin nombre";

    return {
        label: `${name}${contact?.phone ? ` (${contact.phone})` : ""}`,
        value: contact?.id,
    };
};

export const useContactStore = create((set) => ({
    contacts: [],
    contactOptions: [],

    setContacts: (contacts) =>
        set({
            contacts,
            contactOptions: contacts.map(mapContactToOption),
        }),

    add: (newContact) =>
        set((state) => {
            const contacts = [
                ...state.contacts,
                newContact,
            ];

            return {
                contacts,
                contactOptions: contacts.map(mapContactToOption),
            };
        }),

    update: (updatedContact) =>
        set((state) => {
            const contacts = state.contacts.map((contact) =>
                contact.id === updatedContact.id
                    ? updatedContact
                    : contact
            );

            return {
                contacts,
                contactOptions: contacts.map(mapContactToOption),
            };
        }),

    remove: (contactId) =>
        set((state) => {
            const contacts = state.contacts.filter(
                (contact) => contact.id !== contactId
            );

            return {
                contacts,
                contactOptions: contacts.map(mapContactToOption),
            };
        }),
}));